import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const QuickAccessRoutes: Routes = [
  {
    path: "quick-access",
    loadComponent: () =>
      import("./quick-access/quick-access.component").then(
        (m) => m.QuickAccessComponent,
      ),
    canActivate: [AuthGuard],
  },
];
